import type { AdminSubmission } from "@/api";

export function SubmissionsTable({ rows }: { rows: AdminSubmission[] }) {
  if (rows.length === 0) {
    return <p className="px-5 py-10 text-center text-dim">No submissions yet.</p>;
  }
  return (
    <table className="table-asteroi">
      <thead>
        <tr>
          <th className="px-5">ID</th>
          <th>Quiz</th>
          <th>Persona</th>
          <th>Email</th>
          <th className="pr-5">Created</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((s) => (
          <tr key={s.id}>
            <td className="px-5 font-mono text-xs text-faint">{s.id}</td>
            <td className="font-mono text-dim">{s.quiz_slug}</td>
            <td>
              {s.persona ? <span className="tag">{s.persona}</span> : <span className="text-faint">—</span>}
            </td>
            <td>{s.email ?? <span className="text-faint">—</span>}</td>
            <td className="pr-5 tabular-nums text-dim">{new Date(s.created_at).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
